export function makeTileId(level: number, row: number, column: number) {
    return level * 10000 + row * 100 + column;
}

export function parseTileId(tileId: number) {
    const level = Math.floor(tileId / 10000);
    const rowAndColumn = tileId % 10000;
    const row = Math.floor(rowAndColumn / 100);
    const column = rowAndColumn % 100;

    return {
        level,
        row,
        column
    }
}